export const InstergramIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Outer Rounded Square */}
            <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="5"
                stroke={activeColor}
                strokeWidth="2"
            />

            {/* Camera Lens */}
            <circle
                cx="12"
                cy="12"
                r="4"
                stroke={activeColor}
                strokeWidth="2"
            />

            {/* Top Right Dot */}
            <circle
                cx="17"
                cy="7"
                r="1"
                fill={activeColor}
            />
        </svg>
    );
}